import React, { PropTypes } from 'react';
import { TextField, Checkbox } from 'material-ui';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import CancellationRules from './seasonal-cancellation-policy/rules';
import Select from 'react-select';
import R from 'ramda';

const invalidNum = (value) => isNaN(value) || isNaN(parseInt(value, 10)) ? 'Numbers only' : '';

const cancellationsNotValid = data => !R.call(R.allPass([
  R.prop('cancelNum'),
  R.prop('cancelHoursDays'),
  R.prop('conditions'),
]), data);

const checkIfShouldDisable = data => {
  const { adultCount, childrenCount, ageFrom, ageTo, focChildrenAllowed, focChildrenCount, conditions, policyType } = data;
  const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
  const familyPolicyNotValid = () => R.any(isNilOrEmpty, [adultCount, childrenCount]);
  const infantPolicyNotValid = () => R.any(isNilOrEmpty, [ageFrom, ageTo]);
  const childPolicyNotValid = () => R.call(R.anyPass([
    () => isNaN(ageFrom) || isNaN(ageTo),
    () => focChildrenAllowed && !focChildrenCount,
  ]));
  return R.call(R.cond([
    [R.equals('family'), familyPolicyNotValid],
    [R.equals('child'), childPolicyNotValid],
    [R.equals('infant'), infantPolicyNotValid],
    [R.T, () => !conditions],
  ]), policyType);
};

const EditLocationPolicy = ({ onRequestClose, onTextFieldChange, contractId, saveSupplierInfoChanges, data, saving }) => {
  const ages = [];
  for (let i = 0; i < 22; i++) {
    ages.push(({ label: i, value: i }));
  }
  const agesForInfantAndChild = (
    <div style={{ marginLeft: '5%', width: '90%', display: 'flex', alignItems: 'center' }}>
      <p style={{ fontSize: '14px' }}>From</p>
      <div style={{ margin: '4px 0px 20px 10px', width: '23%' }}>
        <Select
          name="ageFrom"
          options={ages}
          value={data.ageFrom}
          onChange={({ value }) => onTextFieldChange({ key: 'ageFrom', value })}
          placeholder={data.policyType === 'child' ? '2' : '0'}
          clearable={false}
          scrollMenuIntoView={false}
        />
      </div>
      <p style={{ fontSize: '14px', marginLeft: '8px' }}>To</p>
      <div style={{ margin: '4px 0px 20px 10px', width: '23%' }}>
      <Select
        name="ageTo"
        options={ages}
        value={data.ageTo}
        onChange={({ value }) => onTextFieldChange({ key: 'ageTo', value })}
        placeholder={data.policyType === 'child' ? '15' : '1'}
        clearable={false}
        scrollMenuIntoView={false}
      />
      </div>
      <p style={{ fontSize: '14px', marginLeft: '8px' }}>(inclusive)</p>
    </div>
  );

  const shouldDisable = checkIfShouldDisable(data);

  const additionalDiv = (() => {
    switch (data.policyType) {
      case 'group':
        return (<small><i/></small>);
      case 'freeOfCharge':
        return (<div/>);
      case 'family':
        return {
          middleDiv: (
            <div style={{ marginLeft: '5%', width: '90%' }}>
              <TextField
                style={{ marginLeft: '20px', width: '27%', marginBottom: '20px', float: 'left' }}
                floatingLabelText="Number of Adults"
                floatingLabelStyle={{ fontSize: '12px' }}
                value={data.adultCount || ''}
                errorText={data.adultCount ? invalidNum(data.adultCount) : ''}
                onChange={({ target: { value } }) => onTextFieldChange({ key: 'adultCount', value })}
              />
              <p style={{ float: 'left', lineHeight: '90px', fontSize: '14px' }}>Adults</p>
              <TextField
                style={{ marginLeft: '10px', width: '30%', marginBottom: '20px', float: 'left' }}
                floatingLabelText="Number of Children"
                floatingLabelStyle={{ fontSize: '12px' }}
                value={data.childrenCount || ''}
                errorText={data.childrenCount ? invalidNum(data.childrenCount) : ''}
                onChange={({ target: { value } }) => onTextFieldChange({ key: 'childrenCount', value })}
              />
              <p style={{ float: 'left', lineHeight: '90px', fontSize: '14px' }}>Children</p>
            </div>
          ),
          textAboveTextField: 'Please note any other conditions related to your Family Policy.',
        };
      case 'child':
        return {
          middleDiv: (<div style={{ display: 'flex', flexDirection: 'column' }}>
            {agesForInfantAndChild}
            <div style={{ marginBottom: '8px', marginLeft: '5%', width: '90%' }}>
              <Checkbox
                checked={Boolean(data.focChildrenAllowed)}
                onCheck={() => onTextFieldChange({ key: 'focChildrenAllowed', value: !data.focChildrenAllowed })}
                label="Children Free of Charge (FOC) when sharing existing bedding with adults"
              />
              <div style={{ display: Boolean(data.focChildrenAllowed) ? 'flex' : 'none', alignItems: 'center', marginLeft: '36px' }}>
                <TextField type="number" hintText="Number" value={data.focChildrenCount || ''} id="focChildrenCount" style={{ width: '100px' }} onChange={({ target: { value } }) => onTextFieldChange({ key: 'focChildrenCount', value })} />
                &nbsp; free children <span style={{ color: 'red' }}> * Required</span>
              </div>
            </div>
            <Checkbox
              checked={Boolean(data.childrenNotAccepted)}
              onCheck={() => onTextFieldChange({ key: 'childrenNotAccepted', value: !data.childrenNotAccepted })}
              style={{ marginLeft: '5%', width: '90%' }}
              label="Children not accepted"
            />
          </div>),
          textAboveTextField: 'Please note any other conditions related to your Child Policy. For example, if a cot or rollaway is required, you will be charged for the additional bedding.',
        };
      case 'infant':
        return {
          middleDiv: (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {agesForInfantAndChild}
              <Checkbox
                checked={Boolean(data.infantAsOccupant)}
                style={{ marginLeft: '5%', width: '90%' }}
                onCheck={() => onTextFieldChange({ key: 'infantAsOccupant', value: !data.infantAsOccupant })}
                label="Infant counts as an occupant"
              />
            </div>
          ),
          textAboveTextField: 'Please note any other conditions related to your Infant Policy. For example, infants are free if they are sharing existing bedding. If a crib is required, you will be charged for the additional bedding.',
        };
      default:
        return (<div/>);
    }
  })();
  const bottomDiv = (
    <div className="flex-tc-sb" style={{ padding: '8px 8px 0px 12px' }}>
        {
          data.policyType === 'cancellation' ? (
            <div style={{ color: data.showError ? 'red' : 'initial' }}>
              {
                data.showError
                  ? 'Please make sure you have filled out all missing information'
                  : `NOTE: Seasonal cancellation policies can be added in the room type/product rates pages.`
              }
            </div>
          ) : <div/>
        }
        <div style={{ width: '200px' }}>
          <FlatButton
            label="Cancel"
            hoverColor="none"
            labelStyle={{ fontWeight: '600', marginRight: '15px' }}
            primary
            onTouchTap={onRequestClose}
          />
          <FlatButton
            label="Save"
            loader={saving}
            hoverColor="none"
            labelStyle={{ fontWeight: '600' }}
            onTouchTap={() => {
              if (data.policyType === 'cancellation') {
                const shoudShowError = cancellationsNotValid(data);
                if (shoudShowError) {
                  return onTextFieldChange({ key: 'showError', value: true });
                }
              }
              saveSupplierInfoChanges({ contractId, data, updateType: 'SAVE_POLICY_ADD_EDIT' });
            }}
            secondary
            disabled={shouldDisable}
          />
        </div>
      </div>
  );
  if (data.policyType === 'cancellation') {
    return (
      <div>
        <div style={{ width: '90%', margin: '20px 0px 12px 5%' }}>
          <CancellationRules
            {...data}
            onChange={(key, value) => onTextFieldChange({ key, value })}
          />
        </div>
        {bottomDiv}
      </div>
    );
  }
  return (
    <div>
      <div style={{ width: '90%', margin: '20px 0px 12px 5%', whiteSpace: 'pre-wrap' }}>{data.note}</div>
      {additionalDiv.middleDiv}
      <div style={{ marginLeft: '5%', width: '90%', fontStyle: 'italic', fontSize: '14px', clear: 'both' }}>{additionalDiv.textAboveTextField}</div>
      <textarea
        style={{ marginLeft: '5%', width: '90%', marginBottom: '8px' }}
        rows={8}
        placeholder="Enter here..."
        defaultValue={data.conditions}
        autoFocus
        onChange={({ target: { value } }) => onTextFieldChange({ key: 'conditions', value })}
      />
      <div style={{ color: 'red', marginLeft: '20px', marginBottom: '16px', fontSize: '12px' }}>* Required</div>

      {bottomDiv}
    </div>
  );
};

EditLocationPolicy.propTypes = {
  onRequestClose: PropTypes.func,
  contractId: PropTypes.string,
  productId: PropTypes.string,
  data: PropTypes.object,
  saveText: PropTypes.func,
  onTextFieldChange: PropTypes.func,
  saving: PropTypes.bool,
};

export default EditLocationPolicy;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/extra-policy-divs.jsx